import { render, staticRenderFns } from "./PdfPresentation.vue?vue&type=template&id=28be3ba3&scoped=true&"
import script from "./PdfPresentation.vue?vue&type=script&lang=js&"
export * from "./PdfPresentation.vue?vue&type=script&lang=js&"
import style0 from "./PdfPresentation.vue?vue&type=style&index=0&id=28be3ba3&prod&scoped=true&lang=css&"
import style1 from "./PdfPresentation.vue?vue&type=style&index=1&id=28be3ba3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28be3ba3",
  null
  
)

export default component.exports